import {createRoute, dynamicWrapper} from '@/utils/core';

const routesConfig = (app) => ({
    path: '/broadcast/index/:token',
    title: '应急广播',
    component: dynamicWrapper(app, [], () => import('./components'))
});

export default (app) => createRoute(app, routesConfig);
